import {
  IDownloadLoaderResponseSchema,
  IDownloadLoaderSubmitSchema,
} from "./downloadLoaderAPI.types";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

const downloadLoaderAPI = (
  data: IDownloadLoaderSubmitSchema
): Promise<{ data: IDownloadLoaderResponseSchema }> => {
  return handleGlobalGetRequestQuery({
    url: "certificates/loader/download",
    searchParams: data,
  });
};

export { downloadLoaderAPI };
